import { Link } from "react-router-dom"
import EntryFeeNotice from "@/components/entry/EntryFeeNotice"

export default function EntryFeePage() {
  return (
    <section className="app-page max-w-[896px]">
      <div className="app-page-head">
        <p className="app-txt-eyebrow text-app-primary-600">ENTRY FEE</p>
        <h1 className="app-txt-h1 mt-3">참가비 · 입금 계좌 안내</h1>
        <p className="app-txt-body2 mt-3 text-app-text-200">
          참가비는 가맹 여부에 따라, 입금 계좌는 종목에 따라 다릅니다. 모든
          대회에 같이 적용됩니다.
        </p>
      </div>

      <div className="app-card">
        <EntryFeeNotice />
      </div>

      <Link
        to="/tournaments"
        className="focus-ring app-btn app-btn-lg app-btn-primary app-btn-block mt-8"
      >
        대회 목록 보기
      </Link>
    </section>
  )
}
